import { setToken, useUserLoader } from "@/libs/auth";
import { useFeatureFlagsLoader } from "@/libs/feature-flags";
import { useLazyWhoamiRetrieveQuery } from "@/services/api";
import { useAppDispatch, useAppSelector } from "@/services/store";
import { Loader } from "@/ui-components/Loader";
import DashboardLayout from "@/ui-components/layouts/DashboardLayout";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import React, { Suspense, useEffect, useState } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { Outlet } from "react-router-dom";

export const SecureRoute: React.FC = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const dispatch = useAppDispatch();
  const [triggerWhoAmI, { data }] = useLazyWhoamiRetrieveQuery();
  const { token, tenant } = useAppSelector(state => state.auth);
  const [whoAmIApplied, setWhoAmIApplied] = useState(false);
  const { showBoundary } = useErrorBoundary();
  const accessToken = authState?.accessToken?.accessToken;

  useFeatureFlagsLoader(tenant?.id);
  useUserLoader(data, () => setWhoAmIApplied(true));

  useEffect(() => {
    if (authState && !authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(window.location.href, window.location.origin);
      oktaAuth.setOriginalUri(originalUri);
      oktaAuth.signInWithRedirect();
    }
  }, [authState?.isAuthenticated]);

  useEffect(() => {
    if (accessToken) {
      dispatch(setToken(accessToken));
    }
  }, [accessToken]);

  useEffect(() => {
    if (token) {
      triggerWhoAmI()
        .unwrap()
        .catch(error => {
          if (error.status === 409) {
            showBoundary({ errors: [error] });
          }
        });
    }
  }, [token]);

  if (!whoAmIApplied) {
    return <Loader />;
  }

  return (
    <DashboardLayout>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </DashboardLayout>
  );
};
